import api from './client';

export const fetchShipmentByOrderId = (orderNumber: string) =>
  api.get('/shipments', { params: { orderNumber } }).then(res => res.data);
